import { Add } from "@mui/icons-material";
import { Grid, Palette } from "@mui/material";
import { useState } from "react";
import { ICodename, IPolicy, PolicyRequirement } from "../../../commons/interfaces";
import { Mode, PolicyRequirementType } from "../../../constants/enums";
import useStrings from "../../../hooks/useStrings";
import Avatar from "../../Avatar";
import Box from "../../Box";
import Button from "../../Button";
import Typography from "../../Typography";
import { ModalAddRequirements } from "../Modal";

export const PolicyRequirements = ({
    mode,
    data,
    groups,
    roles,
    users,
    onAddRequirements,
}: {
    mode: Mode;
    data: IPolicy;
    groups: ICodename[];
    users: ICodename[];
    roles: ICodename[];
    onAddRequirements: (requirements: PolicyRequirement[]) => void;
}) => {
    const Strings = useStrings();
    const [targetVisibled, setTargetVisibled] = useState<boolean>(false);

    const getRequirementName = (type: PolicyRequirementType) => {
        if (type === PolicyRequirementType.Group) return "Phòng ban";
        if (type === PolicyRequirementType.User) return "Người dùng";
        if (type === PolicyRequirementType.Role) return "Vai trò";
        return "";
    };
    const getRequirementValue = (type: PolicyRequirementType, value: string) => {
        if (type === PolicyRequirementType.Group) return groups.find((el) => el.code === value)?.name || "";
        if (type === PolicyRequirementType.User) return users.find((el) => el.code === value)?.name || "";
        if (type === PolicyRequirementType.Role) return roles.find((el) => el.code === value)?.name || "";
        return "";
    };
    const getRequirementAvatarUrl = (type: PolicyRequirementType, value: string) => {
        if (type === PolicyRequirementType.Group) return groups.find((el) => el.code === value)?.detail?.avatarUrl || "";
        if (type === PolicyRequirementType.User) return users.find((el) => el.code === value)?.detail?.avatarUrl || "";
        if (type === PolicyRequirementType.Role) return roles.find((el) => el.code === value)?.detail?.avatarUrl || "";
        return "";
    };

    const getRequirementChipColor = (
        type: PolicyRequirementType
    ): {
        backgroundColor: keyof Palette;
        color: keyof Palette;
    } => {
        if (type === PolicyRequirementType.Group)
            return {
                backgroundColor: "success",
                color: "success",
            };
        if (type === PolicyRequirementType.User)
            return {
                backgroundColor: "error",
                color: "error",
            };
        if (type === PolicyRequirementType.Role)
            return {
                backgroundColor: "info",
                color: "info",
            };
        return {
            backgroundColor: "white",
            color: "dark",
        };
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box alignItems="center" sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h5">{Strings.POLICY.APPLICABLE_TARGETS}</Typography>
                    {mode !== Mode.View && (
                        <Button color={"dark"} onClick={() => setTargetVisibled(true)}>
                            <Add />
                            &nbsp;
                            {Strings.POLICY.ADD_NEW_TARGET}
                        </Button>
                    )}
                </Box>
            </Grid>
            <Grid item xs={12} display="grid" gap={1}>
                <Box display="flex" alignItems="center" flexDirection="row" flexWrap="wrap" gap={1}>
                    <Typography variant="button">Chú thích: </Typography>
                    {[PolicyRequirementType.Group, PolicyRequirementType.User, PolicyRequirementType.Role].map((el) => {
                        const { backgroundColor, color } = getRequirementChipColor(el);
                        return (
                            <Box
                                key={el}
                                sx={({ palette, functions: { rgba } }) => ({
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 10,
                                    border: `1px solid ${palette[backgroundColor].main}`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 1,
                                    backgroundColor: rgba(palette[backgroundColor].main, 0.1),
                                    "& span": {
                                        color: palette[color].main,
                                    },
                                })}
                            >
                                {/* <Avatar
                                    text={getRequirementName(el)}
                                    size={"xs"}
                                    sx={{
                                        border: "1px #dddddd solid",
                                    }}
                                /> */}
                                <Typography variant="caption">{getRequirementName(el)}</Typography>
                            </Box>
                        );
                    })}
                </Box>
                <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1}>
                    {data?.requirements
                        // .reduce((acc, cur) => {
                        //     if (!Helpers.isNullOrEmpty(cur.values)) acc = [...acc, ...cur.values];
                        //     return acc;
                        // }, [])
                        .map((requirement) => {
                            return (requirement.values || []).map((value) => {
                                const name = getRequirementValue(requirement.type, value);
                                const { backgroundColor, color } = getRequirementChipColor(requirement.type);
                                return (
                                    <Box
                                        key={value}
                                        sx={({ palette, functions: { rgba } }) => ({
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: 10,
                                            border: `1px solid ${palette[backgroundColor].main}`,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 1,
                                            backgroundColor: rgba(palette[backgroundColor].main, 0.1),
                                            "& span": {
                                                color: palette[color].main,
                                            },
                                        })}
                                    >
                                        <Avatar
                                            text={name}
                                            src={getRequirementAvatarUrl(requirement.type, value)}
                                            size={"xs"}
                                            sx={{
                                                border: "1px #dddddd solid",
                                            }}
                                        />
                                        <Typography variant="caption">{name}</Typography>
                                    </Box>
                                );
                            });
                        })}
                </Box>
            </Grid>

            {targetVisibled && (
                <ModalAddRequirements
                    key={JSON.stringify(data?.requirements)}
                    requirements={data?.requirements || []}
                    visibled={targetVisibled}
                    roles={roles}
                    groups={groups}
                    serviceCode={data?.serviceCode}
                    onClose={() => setTargetVisibled(false)}
                    onSubmit={onAddRequirements}
                    showTabs={[PolicyRequirementType.User, PolicyRequirementType.Group, PolicyRequirementType.Role]}
                />
            )}
        </Grid>
    );
};

export default PolicyRequirements;
